<template>
    <div>
        <label>
            <i18n path="contacts.addModal.currentToken">
                <i class="text-muted">{{ expiration | formatDate }}</i>
            </i18n>
        </label>
        <div class="row mb-3">
            <div class="col-lg-6">
                <b-form-input
                    type="text"
                    id="current-token"
                    readonly
                    @click.native="selectToken"
                    :value="token"
                />
            </div>
            <div class="col-lg-3 mt-3 mt-lg-0">
                <button
                        class="btn btn-primary btn-block"
                        :disabled="loading"
                        @click="getToken(true)"
                >{{$t('contacts.addModal.getToken')}}
                </button>
            </div>
        </div>
        <label>{{$t('contacts.addModal.contactToken')}}</label>
        <form @submit.prevent="useToken">
            <div class="row mb-3">
                <div class="col-lg-6">
                    <b-form-input type="text" id="contact-token" v-model="tokenInput"/>
                </div>
                <div class="col-lg-3 mt-3 mt-lg-0">
                    <button
                        class="btn btn-primary btn-block"
                        :disabled="loading||!tokenInput"
                        type="submit"
                    >{{$t('contacts.addModal.submitToken')}}
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>


<script>
import {mapGetters} from 'vuex';
import VueQRCodeGenerator from 'vue-qrcode-component';

export default {
    components: {'qr-code': VueQRCodeGenerator},
    data: function () {
        return {
            tokenInput: null,
        };
    },
    computed: mapGetters({
        loading: 'loading/loading/loading',
        token: 'contact/pair/token',
        expiration: 'contact/pair/expiration',
    }),
    methods: {
        getToken: function (force = false) {
            this.$store.dispatch('contact/pair/getToken', force);
        },
        useToken: function () {
            this.$store
                .dispatch('contact/pair/useToken', this.tokenInput)
                .then(() => {
                    this.$router.push({name: 'ContactAdded'});
                });
        },
        selectToken: function (event) {
            event.target.select();
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/contact/PairToken.vue